// external dependencies
import React, { useEffect, useRef } from 'react'
import styled from '@emotion/styled'
import { func, string } from 'prop-types'

// styled components
const Input = styled.input`
	box-sizing: border-box;
	color: ${({ theme }) => theme.colors.text};
	font-size: 16px;
	height: 30px;
	margin: 0;
	width: 100%;
`

NearYouSearch.propTypes = {
	onPlacesChanged: func,
	placeholder: string,
}

/**
 * NearYouSearch
 *
 * Searchbox for the list of services that appears to the side of the "Near You" map
 */
export function NearYouSearch({ onPlacesChanged, placeholder }) {
	const inputRef = useRef(null)

	useEffect(() => {
		const updatePlacedChanged = () => {
			if (onPlacesChanged) {
				onPlacesChanged(searchBox.getPlaces())
			}
		}

		const searchBox = new window.google.maps.places.SearchBox(inputRef.current)
		const searchBoxListener = searchBox.addListener('places_changed', updatePlacedChanged)

		return () => window.google.maps.event.removeListener(searchBoxListener)
	}, [onPlacesChanged])

	return <Input ref={inputRef} placeholder={placeholder} type="text" />
}
